/*
 * @Author: 朱海良 421973703@qq.com
 * @Date: 2023-10-31 10:50:33
 * @LastEditors: 朱海良 421973703@qq.com
 * @LastEditTime: 2023-10-31 10:56:49
 * @FilePath: \zhw\src\router\index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from "@/views/Home.vue";

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "home",
    component: Home
  },
  {
    path: "/Salesnetwork",
    name: "Salesnetwork",
    component: () =>
      import("@/views/components/Salesnetwork.vue")
  },
  {
    path: "/Water",
    name: "Water",
    component: () =>
      import("@/views/components/Water.vue")
  },
  {
    path: "/MeterInstall",
    name: "MeterInstall",
    component: () =>
      import("@/views/components/MeterInstall.vue")
  },
  {
    path: "/EntMeterInstall",
    name: "EntMeterInstall",
    component: () =>
      import("@/views/components/EntMeterInstall.vue")
  },
  {
    path: "/Waterquery",
    name: "Waterquery",
    component: () =>
      import("@/views/components/Waterquery.vue")
  },
  {
    path: "/Waterrate",
    name: "Waterrate",
    component: () =>
      import("@/views/components/Waterrate.vue")
  },
  {
    path: "/Bill",
    name: "Bill",
    component: () =>
      import("@/views/components/Bill.vue")
  },
  {
    path: "/Applyfor",
    name: "Applyfor",
    component: () =>
      import("@/views/components/Applyfor.vue")
  }
]

const router = new VueRouter({
  routes
})

export default router
